const htmlFixer = (html, pageURL) => {
  const isGoogleAds = html?.includes("adsbygoogle");
  const isIncludePageUrl = html?.includes("data-page-url=");
  if (pageURL && isGoogleAds && !isIncludePageUrl) {
    const updatedAd = `<ins class="adsbygoogle"
	data-page-url="${pageURL}"`;
    return html?.replace(new RegExp('<ins class="adsbygoogle"', "g"), updatedAd);
  }
  return html;
};
export {
  htmlFixer
};
//# sourceMappingURL=html-fixer.js.map
